<template>
  <div class="mt-4 flex p-2 sm:p-8">
    <vx-card title="Políticas de envío">
      <p><b>Dentro de la capital</b></p>
      <p>Para compras menores de Q150.00 el costo de envío es Q20.00</p>
      <p>Para compras mayores de Q150.00 el envío es gratis</p>
      <p class="text-xs">(Aplican restricciones)</p>
      <br/>
      <p><b>Fuera de la capital</b></p>
      <p>El costo de envío es Q60.00</p>
    </vx-card>
  </div>

</template>

<script>
    export default {
        name: "ShippingTerms"
    }
</script>

<style scoped>

</style>
